/*************************************************/
/* IMAGES-LINKS                                  */
/*************************************************/

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function imagesLinks() {
    const imageSelector = '.images-links__image';
    const offsets = [250, 200, 150, 100];
    const triggerOffsets = [0,0,0,-350];
    const offsetsMobile = [250, 200];
    const triggerOffsetsMobile = [-300,-300];
    const init = () => {

        const images = document.querySelectorAll(imageSelector);
        if (images.length > 0) {
            const gsapImages = [];
            const gsapImagesMobile = [];

            var mm = gsap.matchMedia();

            mm.add("(max-width:768px)", () => {
                for (let i = 0; i < 2; i++) {
                    const image = images[i];
                    
                    gsapImagesMobile.push(gsap.fromTo('#' + image.id,{y:0,opacity:0},{
                        scrollTrigger: {
                            trigger: '#' + image.id,
                            // start: "-200 80%", //1: trigger, 2: scroller (viewport)
                            // end: "-200 85%", // +=xxx er i forhold til start
                            start: () => { return triggerOffsetsMobile[i] + 'px 60%'},
                            end: () => { return triggerOffsetsMobile[i] + 'px 70%'},
                            scrub: 1,
                            once: true
                        },
                        y: -offsetsMobile[i], 
                        opacity: 1
                    }));
                }
            });

            mm.add("(min-width:769px)", () => {
                for (let i = 0; i < images.length; i++) {
                    const image = images[i];
                    
                    gsapImages.push(gsap.fromTo('#' + image.id,{y:0,opacity:0},{
                        scrollTrigger: {
                            trigger: '#' + image.id,
                            // start: "-200 80%", //1: trigger, 2: scroller (viewport)
                            // end: "-200 85%", // +=xxx er i forhold til start
                            start: () => { return triggerOffsets[i] + 'px 80%'},
                            end: () => { return triggerOffsets[i] + 'px 85%'},
                            scrub: 1,
                            once: true
                        },
                        y: -offsets[i], 
                        opacity: 1
                    }));
                }
            })

            

        }


    };

    init();

}